import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MapViewer from './components';
import PageHeader from '@ui/layout/Layout/components/PageHeader';
import { Box, Button } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
export const MapView = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const lat = searchParams.get('lat');
    const lon = searchParams.get('long');
    const handleBackToDefaultView = () => {
        navigate('/map-view');
    };
    return (_jsxs(Box, { sx: { height: 'calc(100dvh - 220px)' }, children: [_jsx(PageHeader, { title: 'Map View', filters: _jsx(Button, { disabled: lat && lon ? false : true, onClick: handleBackToDefaultView, variant: 'outlined', color: 'primary', children: "Back to Default View" }) }), _jsx(MapViewer, {})] }));
};
